import { cleartaxAxios } from '../../http-common';

class CryptoPageAPIS {
  getBokers() {
    return cleartaxAxios.get('/ct-routes/api/resource/brokers/');
  }
}

export default new CryptoPageAPIS();
